import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Record, slot } from 'src/app/features/Availability/hours-config/models/List.Hours';
import { DirtyComponent } from 'src/app/helpers/CanDeactivate/dirty-component';
import Swal from 'sweetalert2';

export interface DialogData {
  record: Record,
  restaurantId: number,
  selectedHours: any
}
@Component({
  selector: 'app-hours-form',
  templateUrl: './hours-form.component.html'
})
export class HoursFormComponent extends DirtyComponent implements OnInit {
  override formGroup!: FormGroup;
  loading = false;
  isSubmitted = false;

  isUpdate: boolean = this.data.record ? true : false;

  hours:FormControl = new FormControl([], Validators.required);

  selectedHours: any[] = []

  workingSlots: slot[] = [];

  isSelected = false;
  startSelect = false;

  constructor(
    override dialogRef: MatDialogRef<HoursFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    translate: TranslateService,
    private cdr: ChangeDetectorRef
  ) {
    super(translate)
  }

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }

  ngOnInit(): void {
    this.workingSlots = JSON.parse(JSON.stringify(this.data.record.workingSlots));
    if (this.data.selectedHours.filter((item: any) => item.isActive).length == this.data.record.workingSlots?.length) {
      this.isSelected = true
    } else {
      this.isSelected = false
    }
  }

  override canDeactivate(): boolean {
    return this.hours.touched && this.hours.dirty;
  };

  handleTimeDuration(slot: slot) {
    this.startSelect = true;
    const slots = this.workingSlots;
    let selectedTimes: slot[] = [];
    if (this.hours.value.length > 1) {
      slots.forEach(slot => {
        const firstVaueId = slots.find(s => s.id === this.hours.value[0].id)?.id || 0;
        const lastVaueId = slots.find(s => s.id === this.hours.value[this.hours.value!.length - 1].id)?.id || 0;

        if (slot.id >= firstVaueId && slot.id <= lastVaueId) {
          slot.isActive = true;
          selectedTimes.push(slot)
        }
      });
      this.hours.setValue(selectedTimes);
    }
  }
  getSelectedBetweenSlots() {
    this.hours.value!.forEach((hour: any) => {
      const firstSlot = this.workingSlots.find(s => s === (this.hours.value)![0])?.id || '';
      const lastSlot = this.workingSlots.find(s => s === (this.hours.value)![(this.hours.value)!.length - 1])?.id || '';

      // for(let i = firstSlot; i < lastSlot;) {

      // }

      if (hour.id >= firstSlot && hour.id <= lastSlot) {
        hour.isActive = true
      }
    });
  }

  selectAllSlots() {
    if (this.isSelected) {
      this.workingSlots.map(item => {
        item.isActive = false
      })
      this.isSelected = false;
    }
    else {
      this.workingSlots.map(item => {
        item.isActive = true
      })
      this.isSelected = true;
    }
  }

  saveRecord() {
    this.workingSlots.map(item => {
      item.isActive = this.hours.value?.some((x: any) => x.id == item.id) || false
    })

    if ((this.hours.value)!.length > 1) {
      this.data.record.workingSlots = this.workingSlots;
      this.dialogRef.close(this.data.record);
    } else {
      let msg = this.translate.instant('swalMsg.youShouldChooseAtLeastTwoSlots');
      Swal.fire({
        title: this.translate.instant('swalMsg.Failed'),
        text: msg,
        icon: 'error',
        confirmButtonText: this.translate.instant('swalMsg.Ok')
      });
    }
  }
}
